import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import documentTemplateKeys from '@/api/queries/documentTemplates/keyFactory';
import { graphql } from '@/gql';
import { PreviewDocumentInstanceQuery } from '@/gql/graphql';

const PREVIEW_DOCUMENT_INSTANCE = graphql(`
  query PreviewDocumentInstance(
    $templateId: ID!
    $input: PreviewDocumentInstanceInput!
  ) {
    documentTemplate(id: $templateId) {
      id
      name
      previewDocumentInstance(input: $input) {
        documentHtml
      }
    }
  }
`);

const usePreviewDocumentInstance = (
  { templateId, projectId }: { templateId?: string; projectId?: string },
  options?: UseQueryOptions<PreviewDocumentInstanceQuery>
) => {
  const { data, ...rest } = useQuery({
    enabled: !!templateId && !!projectId,
    queryKey: documentTemplateKeys.previewDocumentInstance(
      templateId!,
      projectId!
    ),
    queryFn: () => {
      return gqlClient.request(PREVIEW_DOCUMENT_INSTANCE, {
        templateId: templateId!,
        input: { projectId: projectId! },
      });
    },
    ...options,
  });

  return {
    documentTemplate: data?.documentTemplate,
    documentHtml: data?.documentTemplate?.previewDocumentInstance.documentHtml,
    data,

    ...rest,
  };
};

export default usePreviewDocumentInstance;
